<template>
    <div class="com-menu-wp">
        <div class="w-1200 menu-box">
            <!-- <router-link  :to="item.path"> -->
            <p v-for="(item,index) in menu" :key="index" @click="gotoUrl(item.path)" class="menu-item" :class="isActive(item.path)?' bg-color':''">
                {{item.name}}
            </p>
            <!-- </router-link> -->
        </div>
    </div>
</template>
<script>
export default {
    name:'comMenu',
    data(){
        return{
            currentMenu:'/home',
            menu:[
                {
                    path:'/home',
                    name:'首页',
                    children:[
                        {
                            path:'/homeSearch',
                            name:'搜索列表',
                        },
                        {
                            path:'/homeList',
                            name:'通用列表',
                        },
                        {
                            path:'/homeDetail',
                            name:'通用详情',
                        },
                        {
                            path:'/demoApplication',
                            name:'通用详情',
                        }
                    ]
                },
                {
                    path:'/information',
                    name:'资讯中心',
                    children:[
                        {
                            path:'/companyCenter',
                            name:'企业中心',
                        },
                        {
                            path:'/companyDetail',
                            name:'企业详情',
                        },
                        {
                            path:'/productCenter',
                            name:'产品中心',
                        },
                        {
                            path:'/productDetail',
                            name:'产品详情',
                        },
                        {
                            path:'/informationList',
                            name:'资讯列表',
                        },
                        {
                            path:'/informationDetail',
                            name:'资讯详情',
                        },
                    ]
                },
                {
                    path:'/monitor',
                    name:'监测中心',
                    children:[],
                },
                {
                    path:'/safeguard',
                    name:'保障中心',
                    children:[
                        {
                            path:'/postsale',
                            name:'内容详情'
                        }
                    ],
                },
                {
                    path:'/release',
                    name:'发布中心',
                    children:[

                    ],
                },
                {
                    path:'/communication',
                    name:'交流中心',
                    children:[
                        {
                            path:'/communicationPost',
                            name:'发表新帖',
                        },
                        {
                            path:'/communicationDetail',
                            name:'交流详情',
                        }
                    ],
                },
                {
                    path:'/procurement',
                    name:'招采中心',
                    children:[],
                },
            ],
        }
    },
    methods:{
        isActive(path){
             if(this.$route.path == path){
                    return true;
             }else{
                for(var i =0; i < this.menu.length;i++){
                    if(path == this.menu[i].path){
                        for(var j =0; j<this.menu[i].children.length;j++){
                            if(this.$route.path == this.menu[i].children[j].path){
                                return true;
                            }
                        }
                    }
                }
                return false;
             }
            
            // return path==this.currentMenu;
        },
        gotoUrl(path){
            if(this.$route.path == path){
                return;
            }else{
                this.currentMenu=path;
                this.$router.push(path);
            }
            
        },
        
    }
}
</script>
<style lang="scss" scoped>
.com-menu-wp{
    width:100%;
    height:50px;
    background:#056BD1;
    
}
p{
    margin:0;
    color:white;
    font-size: 18px;
}
.menu-box{
    
    height:100%;
    margin:0 auto;
    display: flex;
    flex-direction:row;
    justify-content: space-between;
}
.menu-item{
    width:100px;
    height:100%;
    line-height:50px;
    text-align: center;
    cursor: pointer;
}
.bg-color{
    background:linear-gradient(0deg,rgba(255,188,74,1),rgba(255,149,0,1));
}
</style>